import { SeeMoreBlock } from "components/blocks";
import { TagLink } from "components/widgets/TagList/TagLink";
import { ITag } from "services/types";
import { routes } from "routes";

export const RelatedTags = (props: {
  tags: string[];
}) => {
  const tags = props.tags.map(tag => ({
    name: tag,
    count: 0,
  }));

  return (
    <SeeMoreBlock
      header="🔥️ Related Tags"
      more={routes.trendingTags()}
      className="trendingTags canvas"
      list={true}
    >
      {tags.map((tag: ITag, index: number) => (
        <TagLink
          key={tag.name}
          tag={tag}
          counts={false}
        />
      ))}
    </SeeMoreBlock>
  );
};
